import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SelectMenu, SimpleModal, toast } from '@livable/saas-react-components';
import { Alert, Button, MenuItem, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const AmenityModal = observer(_ref => {
  var _amenityForm$amenityD;
  let isOpenExternal = _ref.isOpenExternal,
    handleModalCloseExt = _ref.handleModalCloseExt,
    amenityForm = _ref.amenityForm;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleAmenityChange = event => {
    var _store$homeDashboardS;
    amenityForm.updateModelValues({
      commonAreaAmenityId: event.target.value,
      commonAreaAmenityOptionId: (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany.commonAreaAmenities.find(i => i.id === event.target.value)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.commonAreaAmenityOptions[0].id,
      buildingIds: store.homeDashboardStore.getCurrentProperty.propertyInformation.buildings.map(i => i.id)
    });
    // if (event.target.value) setSelectedAmenity(event.target.value);
  };

  // const handleAmenityOptionChange = (event, value, blockEventPropagation = false) => {
  // console.log('handleAmenityOptionChange', event);
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  // blockEventPropagation && event.stopPropagation();
  // if (selectedAmenity && value && amenityOption) {
  //   store.addNewProperty.utilitiesSetupV2.setSelectedAmenityOption(selectedAmenity, value);
  // }
  // if (!selectedAmenity && value) {
  //   setAmenityOption(value);
  // }
  // };

  const isEdit = (amenityForm === null || amenityForm === void 0 ? void 0 : amenityForm.id) !== 'NEW_AMENITY';
  const headerTitle = isEdit ? "".concat(t('general.edit'), " ").concat(amenityForm === null || amenityForm === void 0 || (_amenityForm$amenityD = amenityForm.amenityDetails) === null || _amenityForm$amenityD === void 0 ? void 0 : _amenityForm$amenityD.name) : t('add_new_property_flow.add_common_area_amenity');
  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();
    if (!isEdit) {
      await store.properties.addPropertyCommonAreaAmenityAsync.run(_objectSpread({
        propertyId: store.homeDashboardStore.getCurrentProperty.id
      }, amenityForm), [amenityForm.id, store.homeDashboardStore.getCurrentProperty.id]).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          toast('success', {
            body: ['Successfully added amenity to property!']
          });
          store.homeDashboardStore.getCurrentProperty.details.fetchAmenities({
            forceUpdate: true,
            useUnicInProgress: true,
            customUnicInProgress: [amenityForm.id]
          });
        }
      });
    } else {
      console.log('handleSubmit Edit', amenityForm);
    }
  };
  const GetForm = observer(_ref2 => {
    var _store$homeDashboardS2;
    let handleModalClose = _ref2.handleModalClose;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      className: classes.content
    }, !isEdit && /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.select_which_amenity_to_add')), /*#__PURE__*/React.createElement("div", {
      className: classes.mdSection
    }, !!((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany.commonAreaAmenities.filter(amenityType => !store.homeDashboardStore.getCurrentProperty.details.amenities.map(i => i.commonAreaAmenityId).includes(amenityType.id))) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.length) ? /*#__PURE__*/React.createElement(SelectMenu, {
      id: "amenity-selector",
      value: amenityForm === null || amenityForm === void 0 ? void 0 : amenityForm.commonAreaAmenityId,
      label: "Amenity",
      labelId: "amenity-selector-label",
      onChange: handleAmenityChange
    }, store.homeDashboardStore.getCurrentCompany.commonAreaAmenities.filter(amenityType => !store.homeDashboardStore.getCurrentProperty.details.amenities.map(i => i.commonAreaAmenityId).includes(amenityType.id)).map(amenityType => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: amenityType.id,
        key: amenityType.id
      }, amenityType.name);
    })) : /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('add_new_property_flow.no_amenities_to_add')))), /*#__PURE__*/React.createElement("div", {
      className: classes.modalFooter
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerEven
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      onClick: () => {
        //eslint-disable-next-line @typescript-eslint/no-unused-expressions
        handleModalClose && handleModalClose();
      },
      'custom-attribute': '600-new-billing-module'
    }, "Cancel")), /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerButton
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !(amenityForm !== null && amenityForm !== void 0 && amenityForm.commonAreaAmenityOptionId),
      variant: "priority",
      onClick: event => {
        handleSubmit(event);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        handleModalClose && handleModalClose();
      },
      'custom-attribute': '601-new-billing-module'
    }, isEdit ? t('buttons.confirm') : t('add_new_property_flow.add_amenity')))))));
  });
  return /*#__PURE__*/React.createElement(SimpleModal, {
    key: 'Property_Amenity_Modal',
    trigger: null,
    title: headerTitle,
    isOpen: isOpenExternal,
    handleClose: handleModalCloseExt,
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.cad')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.cad_hint'))), /*#__PURE__*/React.createElement(GetForm, null));
});